<template>
<div class="section">
  <div class="section__header">
    <h2>Мои ученики</h2>
    <back></back>

    <div class="section__menu header-menu">
      <button type="button" class="header-menu__btn" @click="openPopup('AddStudent', null)">
        <i class="fas fa-plus-circle"></i>
        Добавить ученика
      </button>
    </div>
  </div>
  <div class="section__body">
    <div class="studens-list-title">
      <h4>Список учеников ({{ items.length }})</h4>
      <span>Активные: {{ activeStudents }}, Замороженные: {{ blockedStudents }}</span>
      <input class="uk-input" type="text" v-model="student" placeholder="Введите имя ученика">
    </div>
      <ul class="wh-block__items">
        <li class="wh-block__item" :class="item.is_activated ? 'active' : 'frozen'" v-for="(item, i) in filteredList" :key="item.id">
          <router-link :to="'/student/' + item.id">
            <strong>{{ item.name }} <i v-if="item.age > 0">, {{ item.age }} лет</i><i v-if="user.is_course">, до {{item.property.expired }}</i> <i v-if="item.is_activated == 0">(ЗАМОРОЖЕН)</i></strong><br>
            <span v-if="item.class">{{ item.class.title }}</span>
          </router-link>
          <div class="item-buttons">
            <button type="button" class="header-menu__btn" @click="removeStudent(item, i)">
              <i class="fas fa-user-minus"></i>
              Открепить
            </button>
            <button type="button" class="header-menu__btn" @click="openPopup('MoveClass', item.id)">
              <i class="fas fa-angle-double-right"></i>
              Перенести
            </button>
          </div>
          <div v-if="user.is_outside" class="wh-block__del wh-block__del--lock" @click="freezeUser(item)" :uk-tooltip="item.is_activated ? 'заморозить ученика' : 'разморозить ученика'">
            <span :uk-icon="item.is_activated ? 'lock' : 'unlock'"></span></div>
          <div v-if="user.is_outside" class="wh-block__del" @click="delUser(item)" uk-tooltip="удалить ученика">
            <span uk-icon="close"></span></div>
        </li>
      </ul>
  </div>
  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        :moveStudent="true"
        @close-popup="popupIsOpened = false"
        @move-class="moveStudent" 
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import MoveClass from './classes/MoveClass'
import AddStudent from './students/AddStudent'
import { popup_mix } from '../../mixins/popup_mix'
import { mapGetters } from 'vuex'
export default {
  name: "students",
  inject: ['http'],
  mixins: [ popup_mix ],
  data() {
    return {
      student: ''
    }
  },
  components: {
    AddStudent, MoveClass
  },
  computed: {
    ...mapGetters({
      user: 'user',
      items: 'teacher/students'
    }),
    activeStudents() {
      return this.items.filter(s => s.is_activated).length
    },
    blockedStudents() {
      return this.items.filter(s => !s.is_activated).length
    },
    filteredList() {
      return this.items.filter(item => item.name.toLowerCase().includes(this.student.toLowerCase()))
    }
  },
  methods: {
    /* Заморозить / Разморозить ученика */
    freezeUser(item) {
      let data = {
        'user_id': item.id,
        'is_activated': !item.is_activated,
        'teacher_id': this.user.id,
        'limits': this.$store.state.prices
      }
      this.http.post('onFreezeStudent', data).then(res => {
        if (res.data.status == true) {
          this.$store.dispatch('teacher/getStudents');
        } else {
          swal('Ошибка', res.data.message, 'error');
        }
      })      
    },
    delUser(item) {
      swal({
          title: "Внимание!",
          text: `Вы точно хотите удалить ученика ${item.name}? Если вы его удалите, восстановить его будет невозможно`,
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true
        })
        .then((choise) => {
          if (choise) {
            let data = {
              'user_id': item.id
            }
            this.items = _.remove(this.items, function (n) {
              return n.id !== item.id;
            });

            this.http.post('onDeleteStudent', data).then(() => {
              swal('Ученик удален', "", "success");
            })            
          }
        });
    },
    moveStudent(id) {
      let index = this.items.indexOf(this.items.find(item => item.id === id))
      this.items.splice(index, 1)
      swal('Успешно!', 'Ученик перенесён', 'success')      
    },
    removeStudent(item, index) {
      swal({
        title: 'Внимание!',
        text: `Действительно желаете открепить ученика ${item.name}?`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
      })
      .then((choise) => {
        if (choise) {
          this.http.post('onDetachStudentTeacher', { id: item.id }).then(res => {
            this.items.splice(index, 1)
            swal('Успешно!', `Ученик ${item.name} удалён` , 'success')
          })
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })      
    }
  }
}
</script>

<style lang="scss" scoped>
.studens-list-title {
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;

  & h4 {
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.6);
  }

  & span {
    margin-top: 10px;
    font-size: 14px;
  }
}
.wh-block__items {
  width: 100%;
  margin-top: 20px;
}
.uk-input {
  margin-top: 20px;
}

.item-buttons {
  margin-top: 10px;

  & .header-menu__btn {
    font-size: 12px;
  }  
}
</style>
